<template>
    <div class="consultant-container">
      <!-- 🔹 Вопрос с тумблером -->
      <div class="question-row">
        <h2 class="title">Personal career assistant?</h2>
        <label class="switch">
          <input type="checkbox" v-model="isConsultant" />
          <span class="slider"></span>
        </label>
      </div>
  
      <!-- 🔹 Подпись -->
      <p class="subtitle">
        Сколько примерно лет вы работаете в найме/рекрутинге.<br />
        Ваш примерный опыт.
      </p>
  
      <!-- 🔹 Слайдер -->
      <div class="slider-row" v-if="isConsultant">
        <span class="experience-label">Total experience</span>
        <span class="experience-value">{{ experience }} </span>
      </div>
      <input 
        v-if="isConsultant"
        type="range"
        min="1"
        max="10"
        step="1"
        v-model="experience"
        class="experience-slider"
      />
    </div>
  </template>
  
  <script setup>
  import { ref, defineEmits, watch, onMounted } from 'vue';
  import ConsultantService from '../api/ConsultantService.js';
  
  const emit = defineEmits(['save-consultant', 'consultant-changed']);
  
  const isConsultant = ref(false);
  const experience = ref(3);
  const isLoading = ref(false);
  
  // Оригинальные значения при открытии
  const originalIsConsultant = ref(false);
  const originalExperience = ref(3);
  
  const saveConsultant = async () => {
    try {
      isLoading.value = true;
      const userId = localStorage.getItem('user_id');
      if (!userId) throw new Error("user_id не найден в localStorage");
  
      const isConsultantValue = isConsultant.value;
      const consultantExperienceValue = isConsultantValue ? Number(experience.value) : 0;
  
      console.log("📩 Отправляем данные консультанта:", {
        is_consultant: isConsultantValue,
        consultant_experience: consultantExperienceValue
      });
  
      await ConsultantService.updateConsultantStatus(
        userId,
        isConsultantValue,
        consultantExperienceValue
      );
  
      // После сохранения обновляем оригинал
      originalIsConsultant.value = isConsultant.value;
      originalExperience.value = experience.value;
  
      emit('save-consultant');
    } catch (error) {
      console.error('❌ Ошибка при сохранении статуса консультанта:', error);
    } finally {
      isLoading.value = false;
    }
  };
  
  defineExpose({ saveConsultant });
  
  // Следим за изменениями и сравниваем с оригиналом
  watch([isConsultant, experience], () => {
    const changed = (
      isConsultant.value !== originalIsConsultant.value ||
      experience.value !== originalExperience.value
    );
    emit('consultant-changed', changed);
  });
  
  // При открытии страницы запоминаем начальные значения
  onMounted(async () => {
    // Здесь можно дополнительно подгружать из сервиса реальные значения если хочешь
    originalIsConsultant.value = isConsultant.value;
    originalExperience.value = experience.value;
  });
  </script>
  
  <style scoped>
  .consultant-container {
    width: 600px;
    padding: 20px;
    font-family: "Eastman-Regular", sans-serif;
  }
  
  /* 🔹 Вопрос и тумблер */
  .question-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .title {
    font-size: 20px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--header-text-dark);
  }
  
  [data-theme="light"] .title {
    color: var(--header-text-light);
  }
  
  /* 🔹 Подпись */
  .subtitle {
    margin-top: 20px;
    font-size: 14px;
    color: var(--text-muted-dark);
  }
  
  [data-theme="light"] .subtitle {
    color: var(--text-muted-light);
  }
  
  /* 🔹 Слайдер */
  .slider-row {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 5px;
  }
  
  .experience-label {
    font-size: 18px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--header-text-dark);
  }
  
  .experience-value {
    font-size: 18px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--header-text-dark);
  }
  
  [data-theme="light"] .experience-label,
  [data-theme="light"] .experience-value {
    color: var(--header-text-light);
  }
  
  .experience-slider {
    width: 100%;
    accent-color: #2173E5;
  }
  
  /* 🔹 Тумблер */
  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 28px;
  }
  
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0;
    right: 0; bottom: 0;
    background-color: #ccc;
    border-radius: 34px;
    transition: 0.2s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px; width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: 0.2s;
  }
  
  input:checked + .slider {
    background-color: #2173E5;
  }
  
  input:checked + .slider:before {
    transform: translateX(24px);
  }
  </style>